import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconClientSide = ({
  title = "Client side",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="1440-Client-Side"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="New-Services" transform="translate(-160.000000, -4376.000000)">
        <g id="Group-10" transform="translate(160.000000, 4376.000000)">
          <g id="Group-3-Copy">
            <circle
              id="Oval-Client-Side"
              fill="#F77769"
              cx="32"
              cy="32"
              r="32"
            />
            <path
              d="M44,21 C45.1045695,21 46,21.8954305 46,23 L46,41 L48,41 L48,44 C48,44.5522847 47.5522847,45 47,45 L17,45 C16.4477153,45 16,44.5522847 16,44 L16,41 L18,41 L18,23 C18,21.8954305 18.8954305,21 20,21 L44,21 Z M43,23 L21,23 C20.4477153,23 20,23.4477153 20,24 L20,24 L20,41 L44,41 L44,24 C44,23.4477153 43.5522847,23 43,23 L43,23 Z"
              id="Combined-Shape-Client-Side"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg.Icon>
)

export default IconClientSide
